import React, { Fragment } from "react";
import ModalButtons from "./ModalButtons";
import ModalTitle from "./ModalTitle";
import ModalBody from "./ModalBody";

export default function DefaultModal() {
    return (
        <Fragment>
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                    <div className="grow mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <ModalTitle />
                        <ModalBody />
                    </div>
                </div>
            </div>
            <ModalButtons />
        </Fragment>
    );
}
